import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicModule } from "ionic-angular";
import { SlideCmp } from './components/slide-component';
import { SlideController } from "./components/slide-controller";
var SlideModule = (function () {
    function SlideModule() {
    }
    SlideModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        SlideCmp
                    ],
                    providers: [SlideController],
                    exports: [
                        SlideCmp
                    ],
                    imports: [
                        BrowserModule,
                        IonicModule
                    ],
                    schemas: [
                        CUSTOM_ELEMENTS_SCHEMA
                    ]
                },] },
    ];
    /** @nocollapse */
    SlideModule.ctorParameters = function () { return []; };
    return SlideModule;
}());
export { SlideModule };
//# sourceMappingURL=slide.module.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ion2-image-slide/dist/slide.module.js
// module id = 720
// module chunks = 20